import styled from 'styled-components';
import { cssVar } from 'styles/helper';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';

export const LanguageSelectorContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const LanguageSelectorButton = styled(Button)`
  background: var(--brand-900) !important;
  border: none;
  color: var(--text-primary-on-brand);

  &:hover {
    background: var(--brand-800) !important;
    color: var(--text-primary-on-brand);
  }

  &:focus {
    background: var(--brand-900) !important;
    color: var(--text-primary-on-brand);
  }

  @media (max-width: 768px) {
    padding: ${cssVar('spacing-sm')} ${cssVar('spacing-md')};
    font-size: ${cssVar('font-size-text-sm')};
  }
`;

export const LanguageDropdownList = styled(Stack)`
  position: absolute;
  bottom: 100%;
  left: 0;
  min-width: 240px;
  margin-bottom: 8px;
  z-index: 1000;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.2s ease-in-out;

  @media (max-width: 1350px) {
    left: -50px;
  }

  @media (max-width: 768px) {
    min-width: 200px;
  }
`;

export const LanguageDropdownContent = styled(Stack)`
  background: var(--brand-900);
  transition: max-height 300ms ease-in-out;
  box-shadow: ${cssVar('shadow-lg')};
`;

export const LanguageOptionButton = styled.button<{ $isActive: boolean }>`
  background: ${(props) =>
    props.$isActive ? 'var(--bg-primary-solid)' : 'transparent'};
  border: none;
  border-radius: ${cssVar('radius-md')};
  margin: 2px 4px;
  padding: ${cssVar('spacing-md')} ${cssVar('spacing-lg')};
  cursor: pointer;
  transition: background 0.15s ease-in-out;
  text-align: left;
  width: calc(100% - 8px);

  &:hover {
    background: ${(props) =>
      props.$isActive ? 'var(--bg-primary-solid)' : 'rgba(255, 255, 255, 0.05)'};
  }

  &:first-child {
    margin-top: 4px;
  }

  &:last-child {
    margin-bottom: 4px;
  }
`;
